import { render } from "./Page.vue?vue&type=template&id=a77ca184&scoped=true"
import script from "./Page.vue?vue&type=script&lang=ts"
export * from "./Page.vue?vue&type=script&lang=ts"

import "./Page.vue?vue&type=style&index=0&id=a77ca184&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-a77ca184"

export default script